import { useEffect, useState } from 'react'
import { publicApi } from '../../api'
import type { PublicConfig } from '../../api/types'
import { Spinner } from '../../components/ui/Spinner'

interface HealthInfo {
  ok: boolean
  ts: string
}

export function SystemPage() {
  const [cfg, setCfg] = useState<PublicConfig | null>(null)
  const [health, setHealth] = useState<HealthInfo | null>(null)

  useEffect(() => {
    void (async () => {
      try {
        const c = await publicApi.config()
        setCfg(c)
        setHealth({ ok: true, ts: new Date().toISOString() })
      } catch {
        setHealth({ ok: false, ts: new Date().toISOString() })
      }
    })()
  }, [])

  return (
    <div className="page">
      <h1>System</h1>

      <section className="section">
        <h2>Backend</h2>
        {health === null ? (
          <Spinner />
        ) : (
          <dl className="kv">
            <dt>Status</dt>
            <dd>
              <span className={`tag ${health.ok ? 'tag-accent' : 'tag-danger'}`}>
                {health.ok ? 'OK' : 'Nicht erreichbar'}
              </span>
            </dd>
            <dt>Geprüft</dt>
            <dd>{new Date(health.ts).toLocaleString()}</dd>
          </dl>
        )}
      </section>

      <section className="section">
        <h2>ICE-Server</h2>
        {cfg === null ? (
          <Spinner />
        ) : cfg.iceServers.length === 0 ? (
          <p className="muted">Keine ICE-Server konfiguriert.</p>
        ) : (
          <ul className="bullets">
            {cfg.iceServers.map((s, i) => (
              <li key={i}>
                <code>{Array.isArray(s.urls) ? s.urls.join(', ') : s.urls}</code>
                {s.username ? <span className="muted"> · user: {s.username}</span> : null}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  )
}
